<template>
    <div>
        <div class="list">
            <template v-if="list.length">
              <el-table
                :data="list"
                stripe
                style="width: 100%">
                <!-- <el-table-column
                prop=""
                label="接口类型">
                </el-table-column> -->
                <el-table-column
                prop="name"
                label="接口名称"
                >
                </el-table-column>

                <el-table-column
                prop="approveStatus"
                label="审核状态"
                >
                <template slot-scope="scope">
                  <span class="status status0" v-if="scope.row.approveStatus === 0" >
                    待审核
                  </span>
                  <span class="status status1" v-else-if="scope.row.approveStatus === 1">
                    通过
                  </span>
                  <span class="status status2" v-if="scope.row.approveStatus === 2">
                    未通过
                  </span>
                </template>
                </el-table-column>

                <el-table-column
                prop="address"
                label="访问地址" width="400">
                </el-table-column>

                <el-table-column
                prop="method"
                label="请求方式"
                >
                <template slot-scope="scope">
                    {{ getMethText(scope.row.method)}}
                </template>
                </el-table-column>

                <!-- <el-table-column
                prop=""
                label="状态">
                </el-table-column> -->
                <el-table-column
                prop="remark"
                label="描述">
                </el-table-column>
                <el-table-column
                label="操作" width="170">
                <template slot-scope="scope">
                    <div class="btns">
                    <!-- <el-button type="text" class="downBtn" @click="handleEdit(scope.$index, scope.row)"><img src="../../assets/images/xz@2x.png" />下载</el-button> -->
                    <el-button type="text" class="lookBtn" v-if="scope.row.approveStatus === 1" @click="handleCheck(scope.$index, scope.row)"><img src="../../../assets/images/wd@2x.png" />查看文档</el-button>
                    </div>
                </template>
                </el-table-column>
            </el-table>
            </template>
            <template v-else>
              <Nodata />
            </template>
            </div>
            <div class="pageBox">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
                </el-pagination>
            </div>
    </div>
</template>
<script>
import {
  fetchApiList
} from '@/api/api'
import Nodata from '@/components/noData.vue'
export default {
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 10,
      list: [],
    }
  },
  created() {
    this.getList()
  },
  components:{
      Nodata
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getList()
    },
    getList() {
      let params = {
        pageNum: this.pageNum-1,
        pageSize: this.pageSize
      }
      fetchApiList().then(res => {
        this.list = res.data.content
        this.total = Number(res.data.totalElements)
      })
    },
    handleCheck(index, row) {
      this.$router.push({
        name: 'ApiDetail',
        query: {
          data: row.id
        }
      })
    },
    getMethText(num) {
      let str = ''
      if(num === 1) {
        str='POST'
      }else if(num === 2) {
        str='GET'
      }else if(num === 3) {
        str='PUT'
      }else if(num === 4) {
        str='DELETE'
      }
      return str
    }
  }
}
</script>
<style scoped>
.title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }
  .curLink{
    cursor: pointer;
  }
  .link{
    color: rgba(144, 157, 177, 1);
  }
  .content {
    box-sizing: border-box;
    padding: 10px 20px;
  }
  .pageList {
    width: 100%;
    height: calc(100vh - 180px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 40px;
  }
  .pageBox{
    display: flex;
    justify-content: flex-end;
  }
  .downBtn{
    color: #0F5EFF;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .lookBtn{
    color: #0ECEC3;
    cursor: pointer;
    display: flex;
    align-items: center;
  }
  .downBtn img, .lookBtn img{
    width: 12px;
    height: 14px;
    margin-right: 3px;
  }
  .btns{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .status {
    background: rgba(34,94,253,0.1);
    border: 1px solid #225EFD;
    border-radius: 22px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #225EFD;
    text-align: center;
    padding: 3px 15px;
    display: inline-block;
    margin: 1px 0;
  }
  
  .status0{
    background: rgb(230, 239, 255);
    color: 1px solid rgb(34, 94, 253);
    border: 1px solid rgb(34, 94, 253);
  }
  .status1{
    background: rgba(13,193,110,0.1);
    color: #29C87E;
    border: 1px solid #0DC16E;
  }
  .status2{
    background: #eee;
    color: #959595;
    border: 1px solid #ccc;
  }
  /deep/ .el-pagination{
    position: absolute;
    right: 30px;
    bottom: 30px;
  }
  /deep/ .noData{
    height:calc(100vh - 280px);
  }
</style>




// WEBPACK FOOTER //
// src/views/console/components/AuthorizedServe.vue